import React, { Component } from 'react';
import classNames from 'classnames';
import { general } from '../../data';

const imgs = general.imgs;

class GameTile extends Component {
  constructor(){
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleClick(){
    this.props.handleClick({
      challenge: this.props.challenge,
      id: this.props.id,
      owns: this.props.owns,
      party: this.props.party
    })
  }

  handleMouseEnter(){
    if(!this.props.party) return;
    this.props.handleMouseEnter({
      challenge: this.props.challenge,
      id: this.props.id,
      owns: this.props.owns,
      party: this.props.party
    })
  }

  handleMouseLeave(){
    if(!this.props.party) return;
    this.props.handleMouseLeave(this.props.id)
  }

  render(){
    let icon;
    if(this.props.party === 'a') {
      icon = imgs.party_a_house;
    } else if(this.props.party === 'b') {
      icon = imgs.party_b_house;
    }

    let image;

    if(icon){
      image = <img className="square" data-sq-num={ this.props.id } data-sq-owns={ this.props.owns } src={icon} />
    }

    const wrapperClass = classNames(
      'square-wrapper',
      {
        selected: this.props.selected,
        [`district-${this.props.district}`]: this.props.district,
        empty: !icon,
        [`${this.props.preview}`]: this.props.preview
      }
    );

    return (
      <div className={ wrapperClass }
        onClick={ this.handleClick }
        onMouseEnter={ this.handleMouseEnter }
        onMouseLeave={ this.handleMouseLeave }>
        { image }
      </div>
    )
  }
}

export default GameTile;



// WEBPACK FOOTER //
// ./src/components/Shared/GameTile.js